// mealNorms.js — нормы КБЖУ на конкретный приём (по типу приёма)
//
// Распределение суточной нормы по приёмам в %:
//   Завтрак: 30% · Обед: 35% · Ужин: 25% · Перекус: 5% (каждый из 1–2)
// Если тип приёма не указан — берём нейтральные 30% (основной приём).
//
// Проценты одинаковы для всех макронутриентов (калории, белок, жиры,
// углеводы), поэтому суточное соотношение БЖУ сохраняется на каждом приёме.
//
// Каждый приём считается независимо от дневной нормы; т.к. проценты в сумме
// дают ровно 100%, при полном дне (3 приёма + перекусы) сумма сойдётся
// с дневной нормой с допустимой погрешностью округления ±(.5 г).

// Проценты приёма от дневной нормы по типу приёма
const MEAL_PERCENTS = {
  'завтрак': 0.30,
  'обед': 0.35,
  'ужин': 0.25,
  'перекус': 0.05,
  'default': 0.30 // тип не указан — нейтральный основной приём
};

// Определяет тип приёма по тексту (завтрак/обед/ужин/перекус).
// Если тип не найден — возвращает 'default'.
export const detectMealType = (text) => {
  if (!text) return 'default';
  const t = text.toLowerCase();
  if (t.includes('завтрак')) return 'завтрак';
  if (t.includes('обед')) return 'обед';
  if (t.includes('ужин')) return 'ужин';
  if (t.includes('перекус') || t.includes('перекусить') || t.includes('снек')) return 'перекус';
  return 'default';
};

// Считает нормы приёма из дневных норм по типу.
// dailyNorms: { calories, protein, fat, carbs } — дневные (из calculateNorms/Profile)
// Возвращает { calories, protein, fat, carbs, mealType, percent }
export const mealNormsByType = (dailyNorms, mealType) => {
  const type = MEAL_PERCENTS[mealType] !== undefined ? mealType : 'default';
  const pct = MEAL_PERCENTS[type];

  const dCal = dailyNorms.calories || 0;
  const dProt = dailyNorms.protein || 0;
  const dFat = dailyNorms.fat || 0;
  const dCarb = dailyNorms.carbs || 0;

  return {
    calories: Math.round(dCal * pct),
    protein: Math.round(dProt * pct),
    fat: Math.round(dFat * pct),
    carbs: Math.round(dCarb * pct),
    mealType: type,
    percent: Math.round(pct * 100)
  };
};
